import { FlexColumn, FlexRow } from '@editor/components/utilities/layouts';
import { P2, P4 } from '@repo/ui/components/Typography';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const Wrapper = styled(FlexColumn)`
  position: relative;
`;

export const HiddenInput = styled.input`
  position: absolute;
  opacity: 0;
  pointer-events: none;
  width: 100%;
  height: 100%;
`;

const getBorderColor = (isFocused?: boolean, error?: boolean) => {
  if (error) {
    return themeStyle.alertRed;
  }
  if (isFocused) {
    return themeStyle.varInkMedium;
  }
  return themeStyle.varInkLight;
};

export const SlotWrapper = styled(FlexRow)<{
  isFocused?: boolean;
  error?: boolean;
}>`
  width: 41px;
  height: 41px;
  text-align: center;
  font-size: 18px;
  border-radius: ${themeStyle.radiusMedium};
  background-color: ${themeStyle.varBackgroundAlt};
  border: 1px solid
    ${({ isFocused, error }) => getBorderColor(isFocused, error)};
  color: ${({ error }) =>
    error ? themeStyle.alertRed : themeStyle.varInkMain};
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: text;
`;

export const SeparatorWrapper = styled(P2)<{ error?: boolean }>`
  display: flex;
  align-items: center;

  color: ${({ error }) =>
    error ? themeStyle.alertRed : themeStyle.varInkMain};
`;

export const CaretWrapper = styled(FlexRow)`
  position: absolute;
  pointer-events: none;
  inset: 0;
  align-items: center;
  justify-content: center;
`;

export const Caret = styled.div`
  width: 1px;
  height: 20px;
  background-color: ${themeStyle.varInkMedium};
  animation: smooth-blink 1.5s ease-in-out infinite;

  @keyframes smooth-blink {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
  }
`;

export const Title = styled(P2)`
  color: ${themeStyle.varInkMain};
`;

export const ErrorText = styled(P4)`
  margin-top: 5px;
  color: ${themeStyle.alertRed};
`;

export const ResendWrapper = styled(FlexRow)`
  margin-top: 12px;
  gap: 6px;
`;

export const HintText = styled(P2)`
  color: ${themeStyle.varInkMedium};
`;

export const SlotValue = styled(P2)<{ error?: boolean }>`
  color: ${({ error }) =>
    error ? themeStyle.alertRed : themeStyle.varInkMain};
`;

export const ResendButton = styled(P2)<{ isNewThemeActive: boolean }>`
  color: ${({ isNewThemeActive }) =>
    isNewThemeActive ? themeStyle.varBlueMain : themeStyle.varBrandMain};
  cursor: pointer;
  text-decoration: underline;
`;
